<template>
    <section :class="container" v-if="breadcrumbs.length">
        <nav aria-label="breadcrumbs" class="container-fluid pt-0">
            <ul class="breadcrumb px-0 mb-0">

                    <li v-for="(crumb, index) in breadcrumbs"
                        :key="crumb.name"
                        class="breadcrumb-item"
                        :class="{'active': index == breadcrumbs.length -1}"
                        aria-current="page"
                    >
                        <template v-if="index < breadcrumbs.length -1">
                            <router-link :to="linkProp(crumb)">{{ crumbText(crumb) }}</router-link>
                        </template>
                        <template v-else>
                            {{ crumbText(crumb) }}
                        </template>
                    </li>

                <!-- <template v-for="(item, index) in breadCrumb">
                    <li
                        v-if="index < breadCrumb.length -1"
                        :key="item.name" class="breadcrumb-item"
                    >
                        <router-link :to="{name: item.name}">{{ item.title }}</router-link>
                    </li>
                    <li
                        v-else :key="item.name"
                        class="breadcrumb-item active"
                        aria-current="page"
                    >
                        {{ currentTitle }}
                    </li>
                </template> -->
            </ul>
        </nav>
    </section>
</template>
<script>
import Vue from 'vue'
import {isFunction} from '@config/utils';

export default {
    props: {
        container: {
            default: 'ct-breadcrumb'
        }
    },
    data() {
        return {
        }
    },
    computed: {
        breadcrumb() {
            return this.$store.getters.breadcrumb;
        },
        breadcrumbs: function(){
            // let crumbs = []
            // let matched = this.getMatchedRoutes(this.$route.matched) || [];
            // console.log(this.$route.matched, matched);
            // matched.forEach(function (route) {
            //     // Backwards compatibility
            //     let hasBreadcrumb = (parseFloat(Vue.version) < 2)
            //         ? route.handler && route.handler.title
            //         : route.meta && route.meta.title;
            //     console.log('route.meta', route.meta);
            //     if (hasBreadcrumb) {
            //         crumbs.push(route);
            //     }
            // });
            return this.breadcrumb.crumbs || [];
        },
        module() {
            return  this.$store.getters.moduleName;
        }
    },
    methods: {
        // Display the correct breadcrumb text
        // depending on the Vue version
        crumbText: function (crumb) {
            return (parseFloat(Vue.version) < 2) ? crumb.handler.title : (isFunction(crumb.meta.title) ? crumb.meta.title(crumb) : crumb.meta.title)
        },
        // getMatchedRoutes: function(routes) {
        //     // Convert to an array if Vue 1.x
        //     if (parseFloat(Vue.version) < 2) {
        //         routes = (Object.keys(routes)).filter(function (key) {
        //             return !isNaN(key)
        //         }).map(function (key) {
        //             return routes[key]
        //         })
        //     }

        //     return routes
        // },
        linkProp: function (crumb) {
            // If it's a named route, we'll base the route
            // off of that instead
            if (crumb.name || (crumb.handler && crumb.handler.name)) {
              return {
                name: crumb.name || crumb.handler.name,
                params: this.$route.params
              }
            }

            return {
              path: (crumb.handler && crumb.handler.fullPath)
                  ? crumb.handler.fullPath
                  : crumb.path,
              params: this.$route.params
            }
        }
    },
    watch: {
        module: {
            immediate: true,
            handler (value, oldValue) {
                this.$forceUpdate();
            }
        }
    },
}
</script>
